<app-programtitle title="Find the average of a 'n' numbers"></app-programtitle>
<p> Write a program to find the average of a given set of numbers.</p>
<app-editor code="{{program}}"> </app-editor>